import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ModalLoading from "../components/ModalLoading";
import parse from "html-react-parser";
import { requestGet } from "../api/coreInstance";

export default function InboxFragment() {
   const [dataNotification, setDataNotification] = useState([]);
   const [user] = useState(JSON.parse(localStorage.getItem("dompet_user")));
   const dataOutlet = JSON.parse(localStorage.getItem("dompet_detail_outlet"));

   const [showModalLoading, setShowModalLoading] = useState(false);
   const navigate = useNavigate();

   useEffect(() => {
      GetDataNotification();
   }, []);

   async function GetDataNotification() {
      setShowModalLoading(true);

      try {
         // get outlet details
         let res_outlet = await requestGet(`/outlet/kartini/${user.outlet_kartini_id}`);
         let outletKartini = res_outlet.data;

         // get list notifications
         let res_notifications = await requestGet(`/notif?channel_id=${outletKartini.channel_id}&outlet_kartini_id=${outletKartini.outlet_kartini_id}`);
         setDataNotification([...res_notifications.data.data]);
      } catch (error) {
         console.error(error);
      }

      setShowModalLoading(false);
   }

   return (
      <>
         <ModalLoading
            showModal={showModalLoading}
            setShowModal={setShowModalLoading}
         />
         <div className="-mx-2">
            <div className="text-lg font-semibold text-gray-900 uppercase pt-1.5 pb-2 px-4">
               Inbox
            </div>
            <div>
               <ul>
                  {dataNotification.map((notification, i) => (
                     <li
                        key={i}
                        className="border-b border-gray-200 last:border-0"
                     >
                        <div
                           className="block py-2 px-4 hover:bg-gray-50"
                           // to="#0"
                           onClick={() =>
                              navigate("/detail-notification", {
                                 state: notification,
                              })
                           }
                        >
                           <span className="block text-sm mb-2">
                              📣&nbsp;&nbsp;
                              <span className="font-semibold text-gray-700">
                                 {notification.title}
                              </span>
                              <p className="text-gray-600">
                                 {notification.content.length > 220
                                    ? parse(
                                         `${notification.content.substring(
                                            0,
                                            220
                                         )}...`
                                      )
                                    : notification.content}
                              </p>
                           </span>
                           <span className="block text-xs font-medium text-gray-400">
                              {moment(notification.created_at).format(
                                 "DD MMM YYYY"
                              )}
                           </span>
                        </div>
                     </li>
                  ))}
               </ul>
            </div>
         </div>
      </>
   );
}
